import wcShared from '@web-components/shared';
export class WCUtils {
    constructor() {
        this.debounceTimer = [];
    }
    isKsuite() {
        return window['CURRENT_PROJECT'] === 'ksuite';
    }
    setCookie(name, value, durationDays) {
        const d = new Date();
        if (Boolean(durationDays)) {
            d.setTime(d.getTime() + durationDays * 24 * 60 * 60 * 1000);
            const expires = 'expires=' + d.toUTCString();
            document.cookie = name + '=' + value + ';' + expires + ';path=/';
        }
        else {
            document.cookie = name + '=' + value + ';' + ';path=/';
        }
    }
    goToLink(e, link, prevent = true) {
        if (window['CURRENT_PROJECT'] === 'kmeet') {
            const userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.indexOf(' electron/') > -1 && link.url != '#') {
                e.preventDefault();
                if (prevent) {
                    window.open(link.url, '_blank');
                }
                else {
                    window.location.href = link.url;
                }
                return;
            }
        }
        if (window['CURRENT_PROJECT'] === 'manager3') {
            e.preventDefault();
        }
        if (window['CURRENT_PROJECT'] === 'manager3' && Boolean(link.state)) {
            const body = {
                state: link.state,
                stateParams: link.stateParams,
                params: link.params,
            };
            const myEvent = new CustomEvent('wc-go-to-link', { detail: body });
            document.dispatchEvent(myEvent);
        }
        else {
            if (link.url != '#') {
                window.location.href = link.url;
            }
        }
        wcShared?.store?.notifyObservers('hideShow', false);
        return false;
    }
    getCookie(name) {
        name = name + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
    getRandomNumber(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    smoothScrollTo(element, positionY, duration) {
        positionY = Math.round(positionY);
        duration = Math.round(duration);
        if (duration < 0) {
            return Promise.reject('bad duration');
        }
        if (duration === 0) {
            element.scrollTop = positionY;
            return Promise.resolve();
        }
        const startTime = Date.now();
        const endTime = startTime + duration;
        const startTop = element.scrollTop;
        const distance = positionY - startTop;
        // based on http://en.wikipedia.org/wiki/Smoothstep
        const smoothStep = function (start, end, point) {
            if (point <= start) {
                return 0;
            }
            if (point >= end) {
                return 1;
            }
            const x = (point - start) / (end - start); // interpolation
            return x * x * (3 - 2 * x);
        };
        return new Promise(function (resolve) {
            // This is to keep track of where the element's scrollTop is
            // supposed to be, based on what we're doing
            let previousTop = element.scrollTop;
            // This is like a think function from a game loop
            const scrollFrame = function () {
                if (element.scrollTop != previousTop) {
                    return;
                }
                // set the scrollTop for this frame
                const now = Date.now();
                const point = smoothStep(startTime, endTime, now);
                const frameTop = Math.round(startTop + distance * point);
                element.scrollTop = frameTop;
                // check if we're done!
                if (now >= endTime) {
                    resolve(true);
                    return;
                }
                // If we were supposed to scroll but didn't, then we
                // probably hit the limit, so consider it done; not
                // interrupted.
                if (element.scrollTop === previousTop && element.scrollTop !== frameTop) {
                    resolve(true);
                    return;
                }
                previousTop = element.scrollTop;
                // schedule next frame for execution
                setTimeout(scrollFrame, 0);
            };
            // boostrap the animation process
            setTimeout(scrollFrame, 0);
        });
    }
    debounce(func, arg, wait, debounceTimerKey) {
        if (this.debounceTimer[debounceTimerKey]) {
            clearTimeout(this.debounceTimer[debounceTimerKey]);
        }
        this.debounceTimer[debounceTimerKey] = setTimeout(() => {
            func(arg);
            this.debounceTimer[debounceTimerKey] = null;
        }, wait);
    }
    getLang() {
        if (window['CONST_LANG'] && window['CONST_LANG'].shortcode) {
            return window['CONST_LANG'].shortcode;
        }
        else if (window['CONST_LANG']) {
            return window['CONST_LANG'];
        }
        return 'en';
    }
    pmToAm(value, lang, short = false) {
        if (!Boolean(value) || !value.includes(':')) {
            return;
        }
        let hours = parseInt(value.split(':')[0]);
        const minutes = value.split(':')[1];
        switch (lang) {
            case 'en':
                const newHours = hours % 12 || 12;
                const AmOrPm = hours >= 12 ? ' pm' : ' am';
                if (short) {
                    return Boolean(minutes) ? newHours + AmOrPm : newHours + ':' + minutes + AmOrPm;
                }
                else {
                    return newHours + ':' + minutes + AmOrPm;
                }
            case 'de':
                if (short) {
                    return Boolean(minutes) ? hours : hours + '.' + minutes;
                }
                else {
                    return hours + '.' + minutes;
                }
            case 'fr':
                hours = hours < 10 ? '0' + hours : hours;
                if (short) {
                    return Boolean(minutes) ? hours + 'h' : hours + 'h' + minutes;
                }
                else {
                    return hours + 'h' + minutes;
                }
            default:
                hours = hours < 10 ? '0' + hours : hours;
                if (short) {
                    return Boolean(minutes) ? hours : hours + ':' + minutes;
                }
                else {
                    return hours + ':' + minutes;
                }
        }
    }
}
